// extracted by mini-css-extract-plugin
module.exports = {"row":"grid-module--row--3pucA","col":"grid-module--col--2zZVe","revRow":"grid-module--rev-row--g8i8n"};